import React from "react"
import PropTypes from "prop-types"

import { Autocomplete, TextField } from "@mui/material";

const TicketSelector = ({ticket, filteredTickets, onSelect}) => {
  
  return (
    <Autocomplete
            fullWidth
            options={filteredTickets}
            onChange={(event, newValue) => {
              onSelect(event, newValue);
            }}
            disabled={filteredTickets.length === 1}
            getOptionLabel={(option) => `${option.identifier} ${option.available_amount ? " (" + option.available_amount + " left)" : ""}`}
            disableClearable
            value={ticket}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Select Ticket"
                    name="ticket"
                    fullWidth
                    size="small"
                    color="warning"
                    autoFocus
                />
              )}
            />
  );
};

TicketSelector.propTypes = {
  ticket: PropTypes.object,
  filteredTickets: PropTypes.array,
  onSelect: PropTypes.func,
};

export default TicketSelector;